import * as React from 'react';

import styles from './spin-loader.scss';

export const SpinLoader = () => <div className={`${styles.spinLoader}`}/>;
